import { MouseEvent, ReactNode, useState } from 'react';
import { MenuItem } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import { PopoverOrigin } from '@material-ui/core/Popover/Popover';
import I18n from 'i18n-js';

import ButtonClean from '~/components/ButtonClean';

import style from './DropdownCustomized.module.scss';

type TValue = string | number;

type TOption = {
  translation: string;
  value: TValue;
};

interface IDropdownCustomized {
  icon: ReactNode;
  onChange: (value: TValue) => void;
  options: Array<TOption>;
  selected: TValue | undefined;
  className?: string;
  children?: ReactNode;
  anchorOriginVertical?: PopoverOrigin['vertical'];
}

export default function DropdownCustomized({
  className,
  icon,
  onChange,
  options,
  selected,
  children,
  anchorOriginVertical = 'bottom',
}: IDropdownCustomized): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleClick = (event: MouseEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonClean
        onClick={handleClick}
        className={className}
      >
        {icon}
      </ButtonClean>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: anchorOriginVertical,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={style.dropdownMenuWrapper}
        classes={{
          paper: style.dropdownMenu,
        }}
      >
        {children}
        {options.map(({ value, translation }) => (
          <MenuItem
            key={value}
            value={value}
            selected={value === selected}
            className={style.selectOption}
            onClick={() => onChange(value)}
            classes={{
              selected: style.selected,
            }}
          >
            {I18n.t(translation)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
